import { createStore } from "vuex"
import axios from "axios"
// import { Toast, Dialog } from "vant"
// import md5 from "js-md5"
// import { Base64 } from "js-base64"

axios.defaults.withCredentials = true

// let commonURL
// if (process.env.NODE_ENV !== "production") {
//   commonURL = "/api/common"
// } else {
//   commonURL = "https://zsrbactivity.zsnews.cn/"
// }

export default createStore({
  state: {
    showStatement: false,
    statement: "",
    // images: '',
    cropImage: "",
    showPosterMerge: false,
    compresFile: "",
    compresIamge: "",
    poster: ""
  },
  mutations: {
    updateShowStatement(state, showStatement) {
      state.showStatement = showStatement
    },
    updateShowPosterMerge(state, showPosterMerge) {
      state.showPosterMerge = showPosterMerge
    },
    updateCropImage(state, cropImage) {
      state.cropImage = cropImage
    }
  },
  actions: {
    // uploadImg({ commit, state }, filedata) {
    //   new Promise((resolve, reject) => {
    //     const currentTime = new Date().getTime()
    //     const deadline = currentTime + 1000 * 30
    //     const sign = md5(JSON.stringify({ deadline: deadline }))
    //     const data = Base64.encode(JSON.stringify({ deadline: deadline }))
    //     const uploadtoken = sign + ":" + data
    //     let params = new FormData()
    //     params.append("img", filedata)
    //     params.append("uploadtoken", uploadtoken)
    //     params.append("category", "paperposter")
    //     const config = {
    //       headers: {
    //         "Content-Type": "multipart/form-data"
    //       }
    //     }
    //     axios
    //       .post(
    //         // commonURL + "/uploadImg",
    //         "https://zsrbactivity.zsnews.cn/api/common/uploadImg",
    //         params,
    //         config
    //       )
    //       .then((res) => {
    //         if (res.status === 200) {
    //           const data = res.data
    //           console.log(res)
    //           if (data.code === 1) {
    //             // state.images = data.data
    //             commit("updateCropImage", data.data)
    //             Toast.success(data.msg)
    //             resolve(data.data)
    //           } else {
    //             Dialog.alert({
    //               message: data.msg
    //             }).then(() => {
    //               window.location.reload()
    //             })
    //           }
    //         } else {
    //           Toast.fail("上传失败，请重试")
    //           reject()
    //         }
    //       })
    //       .catch(() => {
    //         Toast.fail("网络错误，请重试")
    //         reject()
    //       })
    //   })
    // }
  },
  modules: {}
})
